import { useOutlet } from 'react-router-dom';
import { Affix } from 'antd';
import { isInIframe } from '@/utils';
import { SSearch } from './search';
import { Header } from './head';
import { Footer } from './footer';
import styles from './style.module.scss';

export const SearchLayoutWide = () => {
  const outlet = useOutlet();
  const isIframe = isInIframe()
  
  return (
    <div className={styles.globalWrapper}>
      <Affix>
        {
          !isIframe && (
            <Header noTabs />
          )
        }
        <SSearch />
      </Affix>
      <div className={styles.outLayoutWrapper}>
        <div 
          className={styles.layoutWrapper}
          style={{ width: '100%'}}
        >
          <div className={styles.layoutContent}>{outlet}</div>
        </div>
      </div>

      <div style={{ width: 1200, margin: '0 auto' }}>
        {
          !isIframe && (
            <Footer />
          )
        }
      </div>
    </div>
  );
}; 